import React, { Component } from "react";
import {
    Button,
    Card,
    CardBody,
    Container,
    Row,
    Col,
} from "reactstrap";
import { RiBuildingLine, RiCalendar2Line, RiCalendarCheckLine, RiTeamLine } from "react-icons/ri";
import FeaturesMatrix from "./FeaturesMatrix";
import withNavigateHook from "../../hooks/withNavigationHook";
import {SeoHelper} from "../../components/helpers/SeoHelper";
import {FALLBACK_PRICES, formatPrice, getSubscriptionPrices} from "../../components/helpers/PricingHelpers";

class PaymentSelection extends Component {
    state = {
        prices: FALLBACK_PRICES,
        pricesLoading: true,
    };

    handlePlanSelect = (plan) => {
            const planLabel = plan === "month" ? "monthly" : "annual";
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'begin_registration', {
                plan: planLabel,
                account_type: "individual"
            });
        }

        sessionStorage.setItem("selectedPlan", plan);
        sessionStorage.removeItem("selectedAccountType");
        // Navigate to the respective page
        this.props.navigation(plan === "month" ? "/register/single/monthly" : "/register/single/annually");
    };

    handleTeamPlanSelect = () => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'begin_registration', {
                plan: "annual",
                account_type: "team"
            });
        }

        sessionStorage.setItem("selectedPlan", "year");
        sessionStorage.setItem("selectedAccountType", "team");
        this.props.navigation("/register/team/annually");
    };

    handleEnterprisePlanSelect = () => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', 'begin_registration', {
                plan: "annual",
                account_type: "enterprise"
            });
        }

        this.props.navigation("/register/enterprise");
    };

    componentDidMount() {
        const storedCustomer = sessionStorage.getItem("customer");
        const customer = storedCustomer ? JSON.parse(storedCustomer) : null;
        if (customer?.user?.accountId) {
            this.props.navigation("/your-profile/team");
            return;
        }

        getSubscriptionPrices().then(prices => {
            this.setState({prices, pricesLoading: false});
        });

        if (typeof window.gtag === 'function') {
            window.gtag('event', 'view_pricing');
            window.gtag('event', 'begin_checkout');
        }
    }

    render() {
        const {prices, pricesLoading} = this.state;
        const priceLabel = (value) => pricesLoading ? "Loading..." : formatPrice(value);

        return (
            <>
                <SeoHelper
                    uri="/register/choose-your-plan"
                    title="Choose your Plan | The Worship Bible"
                    description="Create your account and start building scripture-based worship service plans today."
                />

                <div className="position-relative">
                    <section className="section section-lg section-shaped pb-250">
                        <div className="shape shape-style-1 shape-default">
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                            <span />
                        </div>
                        <Container className="py-lg-md d-flex">
                            <div className="col px-0">
                                <Row>
                                    <Col lg="8">
                                        <h1 className="display-3 text-white">
                                            Choose your plan{" "}
                                            {/*<span>choose your plan</span>*/}
                                        </h1>
                                    </Col>
                                </Row>
                                <Row className="justify-content-center mb-0 mt-2">
                                    <Col lg="9">
                                        <div
                                            style={{
                                                background: "rgba(255,255,255,0.95)",
                                                borderRadius: "0.5rem",
                                                padding: "2rem",
                                                textAlign: "center"
                                            }}
                                        >
                                            <p className="lead font-weight-normal mb-2 mt--1 text-primary">
                                                You’re almost there.
                                            </p>

                                            <p className="text-muted mb-2" style={{ maxWidth: "720px", margin: "0 auto" }}>
                                                Choose how you’d like to pay. All plans give you full access to all features, and you can change or cancel at any time.
                                            </p>

                                            <p className="text-muted mb-0">
                                                Secure payment processing. We never store your card details.
                                            </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                        <div className="separator separator-bottom separator-skew">
                            <svg xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" version="1.1" viewBox="0 0 2560 100" x="0" y="0">
                                <polygon className="fill-white" points="2560 0 2560 100 0 100" />
                            </svg>
                        </div>
                    </section>
                </div>
                <section className="section section-lg pt-lg-0 mt--200">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg="6">
                                <Card className="card-lift--hover shadow border-0">
                                    <CardBody className="py-5 text-center">
                                        <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                            <RiCalendar2Line color='#5e72e4' size="36" /> Monthly Plan
                                        </h2>
                                        <p className="description mt-3">Pay {priceLabel(prices.individual.monthly)} per month and enjoy full access.</p>
                                        <Button
                                            color="primary"
                                            onClick={() => this.handlePlanSelect("month")}
                                        >
                                            Select Monthly ({priceLabel(prices.individual.monthly)})
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="6">
                                <Card className="card-lift--hover shadow border-0">
                                    <CardBody className="py-5 text-center">
                                        <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                            <RiCalendarCheckLine color='#5e72e4' size="36" /> Annual Plan
                                        </h2>
                                        <p className="description mt-3">Pay {priceLabel(prices.individual.annual)} per year and save over 20%.</p>
                                        <Button
                                            color="primary"
                                            onClick={() => this.handlePlanSelect("year")}
                                        >
                                            Select Annual ({priceLabel(prices.individual.annual)})
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="6">
                                <Card className="card-lift--hover shadow border-0 mt-4">
                                    <CardBody className="py-5 text-center">
                                        <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                            <RiTeamLine color='#5e72e4' size="36" /> Group Annual
                                        </h2>
                                        <p className="description mt-3">
                                            {priceLabel(prices.group.annual)} per year — annual billing only, for up to 10 members.
                                        </p>
                                        <Button color="primary" onClick={this.handleTeamPlanSelect}>
                                            Select Group Annual ({priceLabel(prices.group.annual)})
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                            <Col lg="6">
                                <Card className="card-lift--hover shadow border-0 mt-4">
                                    <CardBody className="py-5 text-center">
                                        <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase">
                                            <RiBuildingLine color='#5e72e4' size="36" /> Organisation
                                        </h2>
                                        <p className="description mt-3">
                                            {priceLabel(prices.enterprise.annual)} per year admin fee — unlimited seats, for dioceses, denominations, and institutions with per seat billing @ £1.67 per seat.
                                        </p>
                                        <Button color="primary" onClick={this.handleEnterprisePlanSelect}>
                                            Select Organisation ({priceLabel(prices.enterprise.annual)})
                                        </Button>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <FeaturesMatrix/>
            </>
        );
    }
}

export default withNavigateHook(PaymentSelection);
